import React,{useEffect} from "react";
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import NavigationMenu from '../NavigationMenu';
import { useNavigate } from 'react-router-dom';
import Footer from './../common/Footer';
import {invalidateToken} from "../services/Service"
function Dashboard(props) {
  const navigate=useNavigate();

    useEffect(() => {
      window.scrollTo(0, 0);
      invalidateToken(sessionStorage.getItem("securitytoken")).then((res) => {
          console.log(res.message);
        }).catch((error) => {});

        }, []);


    return(
        <Box sx={{ display: 'flex' }}>  
            <NavigationMenu pageName={"Dashboard"}/>

      <Box className="pageContainer2">
      <Box width='100%' className="bg-dashboard-image"> 

          <Box width='100%' sx={{ paddingRight:'10px'}}>
            <Box className="text-Section">
              <Typography  sx={{fontWeight:'500', fontSize:'20px', textTransform: 'uppercase', fontFamily: 'Quicksand', paddingTop:'20px'}}>Welcome to your</Typography>
              <Typography sx={{fontWeight:'500', fontSize:'35px', textTransform: 'uppercase', fontFamily: 'Quicksand'}}>Wellbeing Wheel</Typography>
              <Typography sx={{fontWeight:'500', fontSize:'18px'}}>
              The DECAMA Wellbeing Wheel has ten ‘elements’ forming sectors of a Wheel; each element can be scored 1-10 according to how you feel about the element.
              </Typography>
            </Box>
            </Box>
            <Box
                    width='100%'
                    display='flex'
                    justifyContent='center'
                    sx={{paddingTop:'30px'}}
                    >
                        <Box
                    width='80%'
                    display='flex'
                    justifyContent='center'
                    >
                        <Box component="img"
                        sx={{display: "flex",justifyContent: "space-between", width:'300px', paddingLeft:'20px',paddingRight:'20px'}}
                      alt="Org Image"
                      src={process.env.PUBLIC_URL + "/images/wheel.png"} />
                      </Box>
       

                </Box>
                <Box
                  width='100%'
                  display='flex'
                  justifyContent='center'
                  sx={{paddingTop:'30px'}}
                  >
                    <Box component="img"
                    justifyContent='center'
                          sx={{ paddingLeft:'20px',paddingRight:'20px', width:'100%', maxWidth:'400px'}}
                          alt="Org Image"
                          src={process.env.PUBLIC_URL + "/images/take-the-servey-button.png"}
                          onClick={()=>{
                            navigate("/survey");
                            }}
                      />
                  </Box>
                  <Box
                  width='100%'
                  display='flex'
                  justifyContent='center'
                  sx={{paddingTop:'30px', paddingBottom:'30px'}}
                  >
                    <Box component="img"
                    justifyContent='center'
                          sx={{ paddingLeft:'20px',paddingRight:'20px', width:'100%', maxWidth:'400px'}}
                          alt="Org Image"
                          src={process.env.PUBLIC_URL + "/images/wheel-guide-button.png"}
                          onClick={()=>{
                            navigate("/wheelguide");
                            }}
                      />
          </Box></Box>


    <Box
      width='100%'
      sx={{paddingTop:'30px', paddingLeft:'20px', paddingRight:'20px', paddingBottom:'20px', backgroundColor:'#4080A0'}}
      >
        <Typography sx={{fontSize:'24px', fontWeight:'400', color:'white', paddingBottom:'20px'}}>
            THE 10 ELEMENTS:
          </Typography>
      <Accordion>
        <AccordionSummary
        sx={{flexDirection: 'row-reverse'}}
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Physical Health</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{paddingLeft:'25px'}}>
            The DECAMA Wellbeing Wheel invites you to think about what you think about your physical health. Your physical health is a major component of your overall well-being. Physical health and mental or emotional wellbeing are strongly inter-connected.<br/><br/> 
            Paying attention to diet, levels of exercise and sleep quality are often quick ways to improve your physical and mental health<br/><br/> 
            Even a short-term change in your physical health such as having an infection or pain due to injury or associated with menstruation, all affect how you feel in your day-to-day life.<br/><br/>
            Longer term health problems, such as chronic pain can affect your mood, make you feel stressed and irritable or angry with others; you might feel confused about whether to ‘fight ‘the pain or rest – the pain affects how you eat, sleep, it can reduce enjoyment of taking part in usual family or social activities.<br/><br/> 
            Completing the DECAMA Wellbeing Wheel can help you think about areas of your wellbeing where you may be able to make small changes that make a difference in to how you feel overall.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        sx={{flexDirection: 'row-reverse'}}
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography component="span">Mental Health</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{paddingLeft:'25px'}}>
          This element is about your mental or emotional health; if you experience low mood, worry, stress, sleep difficulties, you may wish to score this as ‘poor mental health’ (and give a score of 1-5) If you feel happy, energised or optimistic, you may wish to think about this as having ‘good mental health’ (and give a score of 6 or higher).<br/><br/>
          However, the question is not about admitting you have signs and symptoms of mental health problems, but rather how you feel in general about your mental health.<br/><br/>
          Your circumstances may have changed, and you feel better or worse than previously - what is important is to be honest each time you complete the DECAMA Wellbeing Wheel
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
        sx={{flexDirection: 'row-reverse'}}
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Family</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{paddingLeft:'25px'}}>
          This element is about how you feel towards your family (or, if you don’t have immediate family) about other close relationships. 
          If you have no living family members, think about relationships with family members when they were alive. If you have a mix of good and poor relationships, consider how you feel overall when you think about the people concerned.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        sx={{flexDirection: 'row-reverse'}}
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Social Relationship</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{paddingLeft:'25px'}}>
          This element is about your connections with people outside the immediate family.<br/><br/>
          The people concerned can be geographically close (as in the same neighbourhood or social grouping) or at a distance, with relationships being supported by telephone, letter or other forms of communication.<br/><br/>
          Social relationships may be long-standing or new; consider your involvement in different types of groups; consider the support you receive from and assistance you have given to others, such as in a volunteer or unpaid capacity.<br/><br/>
          The ‘element’ also includes your views of work relationships (if in employment or self-employed). If you enjoy the company of work colleagues and feel good about being at work (score 6 or above); if the working environment is uncomfortable or even toxic and you dread going to work, then score 5 or less.<br/><br/>
          If you feel good about some aspects of your social or work relationships but not good about others, consider your overall view about these work and social connections. Which has the most impact?
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        sx={{flexDirection: 'row-reverse'}}
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Fulfilment</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{paddingLeft:'25px'}}>
          This element refers to how happy you feel about your life in general; it is more than ‘satisfaction’ with life and considers whether you feel you are making use of your personal strengths, knowledge and capabilities. This could be in connection with work and career, family, social life or sports and pastimes.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        sx={{flexDirection: 'row-reverse'}}
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Environment</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{paddingLeft:'25px'}}>
          This element is about your views of the environment around you, this can refer to your home, your work environment or your neighbourhood. You may wish to think about the physical aspects of the environment, people aspects or both.<br/><br/>
          The physical environment - what you see, hear and smell is important for physical and psychological wellbeing. Outside space for movement, seeing the sky, feeling the air, help us to breathe more freely, feel refreshed and relaxed.<br/><br/>
          Even having plants in a room or pictures on the wall have been shown to make you feel better and more comfortable in that setting. Many businesses make improvements to the appearance and ‘feel’ of a building by introducing natural light. There is evidence of such benefits for hospital patients as well as office employees.<br/><br/>
          Access to natural light and sunshine improves vitamin levels and helps raise mood.<br/><br/> 
          All this is enhanced by movement and exercise in the open air and in green spaces.<br/><br/>
          In contrast, environments which are enclosed with limited access to natural light can feel constrictive and punitive, having a huge impact on mental wellbeing.<br/><br/>
          People are also part of 'the environment'; in a work context, our relationships with work colleagues, the language people use to speak with each other or about the work, all form part of the 'working environment'. Working in a psychologically safe environment is important for positive wellbeing and more employees are more likely to feel they are having 'good days' at work. The main sources of work-related stress are in connection with poor working relationships, high demand and uncertainty in the job role.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        sx={{flexDirection: 'row-reverse'}}
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Career & Business Aspirations</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{paddingLeft:'25px'}}>
          This element refers to how you feel at the moment about your work, career or business.<br/><br/> 
          It can also refer to your aspirations and intentions for your future regarding your career, profession or business life – you may feel that you have achieved what you want (score 6 or above), or perhaps that you are yet to achieve what you would like to do (score 5 or less). You might also give a score that reflects whether you would like to continue as now or do something different for the future<br/><br/>
          If you do not have a formal career, (such as a home maker, carer or unpaid volunteer or you may have retired from paid employment), consider how you feel about that carer, volunteer or retired role  - are you satisfied in that role (score 6 or higher) or do you aspire to doing anything different (score 5 or lower).
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        sx={{flexDirection: 'row-reverse'}}
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Financial Status</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{paddingLeft:'25px'}}>
          This element refers to your perception of the balance between individual and/or family income and expenditure.<br/><br/>
          It is not about being financially wealthy or impoverished, but rather whether you consider the level of income to be sufficient for your individual or family lifestyle.<br/><br/>
          Financial wellbeing is an important component of overall wellbeing; we can feel stretched financially, with a big and often stressful impact, on many day-to-day decisions and activities.<br/><br/>
          In contrast, despite being stretched, some people may feel ‘pleased’ to be able to manage the challenge of balancing their income and expenditure.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        sx={{flexDirection: 'row-reverse'}}
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Decision Making</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{paddingLeft:'25px'}}>
          This element is about how much freedom or autonomy you feel you have in making decisions about matters you come across in your everyday life.<br/><br/>
          When you think about decision-making you may wish to think about this in relation to yourself as an individual, in connection with your family or in your work role. The extent to which we make decisions in everyday life is often taken for granted.<br/><br/>
          One of the main features of ‘lockdowns’ during the COVID pandemic of 2020 and 2021, was the government imposing restrictions on work, social and leisure activities. This led to people needing to think about whether they ‘were allowed’ take part in ordinary ‘taken for granted’ activities, such as shopping, holidays, visiting family members. Many people felt that the government was 'taking away' their freedom to make their own decisions and talked about how this affected their mental health.<br/><br/>
          For decision-making at work, being confused or held back in making decisions or being told what to do, can all undermine your sense of feeling safe at work.<br/><br/>
          It is important to consider that for some people, decision-making may be a collective or family matter rather than an individual responsibility. For scoring this element, think about how you feel about your own circumstances.<br/><br/>
          When scoring this element, you may find that your scope for decision-making varies in different circumstances (personal, family or work); consider an overall score based on your view of which area has the most impact on your wellbeing.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        sx={{flexDirection: 'row-reverse'}}
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Sustainability</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{paddingLeft:'25px'}}>
          This element concerns the extent to which your way of life can be sustained, given your present circumstances, future aspirations, financial and personal resources.<br/><br/>
          ‘Wellbeing’ is how you feel about your way of life as a whole.<br/><br/>
          It is also about resilience - the extent to which you can respond to and manage challenges to your day-to-day life. <br/><br/>
          For the DECAMA Wellbeing Wheel, ‘Sustainability’ refers to your personal circumstances, rather than to the concept of 'sustainability' as an economic or social intention.
          </Typography>
        </AccordionDetails>
      </Accordion>

      </Box>
      <Footer takethesurvey />
        </Box>
        </Box>
    );
}
export default Dashboard;